import { DecodedValueMap, StringParam, NumberParam, createEnumParam } from 'use-query-params';
import ArrayParam from '../utils/ArrayParam';
import DateParam from '../utils/DateParam';
import { ActivitySearchOrderEnum } from '../generated/graphql';

export const activitySearchFilterParams = {
    placeId: StringParam,
    themeSlugs: ArrayParam,
    targetAudiences: ArrayParam,
    companyId: StringParam,
    rating: NumberParam,
    order: createEnumParam<ActivitySearchOrderEnum>([
        ActivitySearchOrderEnum.Random,
        ActivitySearchOrderEnum.ReviewRatingDesc,
    ]),
};

export const activitySearchViewParams = {
    startDate: DateParam,
    endDate: DateParam,
    view: StringParam,
};

const activitySearchParams = {
    ...activitySearchFilterParams,
    ...activitySearchViewParams,
};

export default activitySearchParams;

export type ActivitySearchParams = Partial<DecodedValueMap<typeof activitySearchParams>>;
